import { address as mezoMainnetAddress } from "@mezo-org/mezod-contracts/deployments/mainnet/mT.json"
import { address as mezoTestnetAddress } from "@mezo-org/mezod-contracts/deployments/testnet/mT.json"
import { Address } from "viem"

import artifacts from "#/shared/utils/artifacts"

export default artifacts.getBridgeableERC20TokenArtifact({
  mainnetAddress: "0xCdF7028ceAB81fA0C6971208e83fa7872994beE5",
  testnetAddress: "0x46abDF5aD1726ba700794539C3dB8fE591854729",
  mezoTestnetAddress: mezoTestnetAddress as Address,
  mezoMainnetAddress: mezoMainnetAddress as Address,
})
